<template>
  <div class="FinalizePaymentEpay">
    <form
      ref="form"
      :action="orderData.url"
      class="text-center"
      type="POST"
    >
      <input
        v-for="field in orderData.fields"
        :key="field.name"
        :name="field.name"
        :value="field.value"
        type="hidden"
      >
      <div class="mb-6 lg:w-3/5 mx-auto leading-normal">
        <fancy-heading title="ВНИМАНИЕ!" />
        <div class="mb-4">Следва пренасочване към ePay.bg след</div>
        <div class="text-center text-xl mb-4">
          <span class="text-3xl">{{ timeUntilRedirect }}</span> сек.
        </div>
        <div>При избор за плащане <strong>“В брой на каса”</strong> или <strong>“Банкомат”</strong> ще получиш</div>
        <div class="text-2xl text-red my-6">уникален 10 цифрен код.</div>
        <img src="@/assets/images/epay-code.jpg" alt="">
        <div class="my-4">
          Запиши кода или <strong>му направи скрийншот</strong>, защото е видим само докато си на страницата.
        </div>
      </div>
      <v-button
        type="submit"
        class="is-red"
      >
        Продължи към Epay
      </v-button>
    </form>
  </div>
</template>

<script>
/**
 * @module FinalizePaymentEpay
 */
export default {
  name: 'FinalizePaymentEpay',
  props: {
    orderData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      timeUntilRedirect: 20,
      timeout: null
    }
  },
  mounted () {
    this.timeout = setInterval(() => {
      if (this.timeUntilRedirect <= 0) {
        return this.finalize()
      }
      this.timeUntilRedirect--
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timeout)
  },
  methods: {
    finalize () {
      clearInterval(this.timeout)
      this.$refs.form.submit()
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
